import yt from '../modules/yt.js'
export default [
    // 支付订单
    // { path: '/yt/payOrder', name: 'payOrder', component: yt.payOrder,meta:{single:true,title: '支付订单'}},
    { path: '/yt/payOrder', name: 'payOrder', component: yt.payOrder,meta:{single:true,title: '会员缴费'}},
    // 支付成功
    { path: '/yt/paySucceed', name: 'paySucceed', component: yt.paySucceed,meta:{single:true,title: '支付结果'}},
    // 支付失败
    { path: '/yt/payFailure', name: 'payFailure', component: yt.payFailure,meta:{single:true,title: '支付结果'}},
    // IOS不支持
    { path: '/yt/payNoSupport', name: 'payNoSupport', component: yt.payNoSupport,meta:{single:true,title: '会员缴费'}},
    // 云投H5支付备审页
    { path: '/yt/index', name: 'index', component: yt.index,meta:{title:"首页"}},
    // 云投会员缴费
    { path: '/yt/memberPay', name: 'memberPay', component: yt.memberPay,meta:{title:"会员缴费"}},

	//云信流转图
	{path: '/yt/circulationImg',name:'circulationImg', component:yt.circulationImg},
] 